export default __webpack_public_path__ + "static/media/bandeau-catalogue-mobile-es.daa4c7c6.png";